import { TweetStatsOverviewSchema, UserTweetsResponseSchema } from '@sweetistics/contracts';
import type { z } from 'zod';

export type UserTweetsResponseInput = z.input<typeof UserTweetsResponseSchema>;
export type UserTweetsResponseOutput = z.output<typeof UserTweetsResponseSchema>;

export function serializeUserTweetsResponse(payload: UserTweetsResponseInput): UserTweetsResponseOutput {
  const pagination =
    payload.pagination ??
    ({
      page: 1,
      limit: 20,
      cursor: null,
      totalCount: 0,
      hasMore: false,
    } satisfies UserTweetsResponseInput['pagination']);

  const normalizedPagination = {
    page: pagination.page ?? 1,
    limit: pagination.limit ?? 20,
    cursor: pagination.cursor ?? null,
    totalCount: pagination.totalCount ?? 0,
    hasMore: pagination.hasMore ?? Boolean(pagination.cursor),
  };

  return UserTweetsResponseSchema.parse({
    ...payload,
    pagination: normalizedPagination,
  });
}

export type TweetStatsOverviewInput = z.input<typeof TweetStatsOverviewSchema>;
export type TweetStatsOverviewOutput = z.output<typeof TweetStatsOverviewSchema>;

export function serializeTweetStatsOverview(payload: TweetStatsOverviewInput): TweetStatsOverviewOutput {
  return TweetStatsOverviewSchema.parse(payload);
}
